import React, { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CircleIcon from "@mui/icons-material/Circle";
import { GetSimilarLoanResponse } from "../../models/loan.model";

interface props {
  dataFlag: string;
  similarLoanData: GetSimilarLoanResponse[];
}

export default function SimilarLoan({ dataFlag, similarLoanData }: props) {
  const [isExpanded, setExpanded] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });

  const activePage = localStorage.getItem("setActivePage");
  const handleDetail = (referenceKey: string) => {
    window.sessionStorage.setItem("id", referenceKey);
    const newWindow = window.open(
      `/#/loan/${activePage}1/loan-detail`,
      "_blank"
    );
    newWindow?.history.pushState(
      {
        settlementData: { id: referenceKey },
      },
      "",
      `loan/${activePage}1/loan-detail`
    );
  };
  function handelCollapse() {
    setExpanded(!isExpanded);
  }

  if (similarLoanData) {
    return (
      <Box
        sx={{
          margin: "1.9vh",
          direction: "rtl",
          overflowX: "none",
          border: "2px solid #FB8C00",
        }}
      >
        <div
          className="boxView  borderCOlor"
          style={{ background: "#F6F8F9", padding: "10px" }}
        >
          <div
            onClick={handelCollapse}
            style={{
              backgroundColor: "#FB8C00",
              height: "4vh",
              marginBottom: "-1.4vh",
              marginRight: "-11px",
              marginLeft: "-11px",
              marginTop: "-11px",
            }}
            className="centerVertical"
          >
            <span
              style={{
                backgroundColor: "#FB8C00",
                color: "#fff",
                fontSize: "16px",
                marginRight: "2vh",
              }}
            >
              <NotificationImportantOutlinedIcon /> سایر پرونده های تسهیلات
              متقاضی &nbsp;
            </span>
            {isExpanded ? (
              <ArrowDropUpIcon style={{ color: "#fff" }} />
            ) : (
              <MoreHorizIcon style={{ color: "#fff" }} />
            )}
          </div>
          <section {...getCollapseProps()}>
            <br />
            <br />

            {similarLoanData!.map((item: any) => (
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                style={{
                  background: "#F6F8F9",
                  color: "#9AAFC4",
                  width: "100%",
                }}
              >
                <Grid item xs={6} style={{ fontSize: "15px" }}>
                  <CircleIcon
                    style={{ color: "#FB8C00", width: "7px", height: "7px" }}
                  />
                  &nbsp; طرح تسهیلات:{" "}
                  <b style={{ color: "#34495E" }}>{item.loanTemplateTitle}</b>
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  style={{
                    border: "1px solid #DAE0E4",
                    borderRadius: "3px",
                    //   width: "90%",
                    background: "#fff",
                    margin: "15px 25px",
                    padding: "4px 7px 7px 7px",
                  }}
                >
                  <Grid item xs={12} md={6} sm={6} lg={4} xl={3}>
                    تامین کننده مالی:{" "}
                    <b style={{ color: "#34495E", whiteSpace: "nowrap" }}>
                      {item.financialSupplierTitle}
                    </b>
                  </Grid>
                  <Grid item xs={12} md={6} sm={6} lg={4} xl={2}>
                    مبلغ تسهیلات:{" "}
                    <b style={{ color: "#34495E", whiteSpace: "nowrap" }}>
                      {item.amount.toLocaleString()} ریال
                    </b>
                  </Grid>
                  <Grid item xs={12} md={6} sm={6} lg={4} xl={2}>
                    نوع بازپرداخت:{" "}
                    <b style={{ color: "#34495E", whiteSpace: "nowrap" }}>
                      {item.repaymentTypeTitle}
                    </b>
                  </Grid>
                  <Grid item xs={12} md={6} sm={6} lg={4} xl={2}>
                    وضعیت :{" "}
                    <b style={{ color: "#34495E", whiteSpace: "nowrap" }}>
                      {item.loanRequestStatusTitle}
                    </b>
                  </Grid>
                  <Grid item xs={12} md={6} sm={6} lg={4} xl={2}>
                    تاریخ ثبت درخواست:{" "}
                    <b style={{ color: "#34495E", whiteSpace: "nowrap" }}>
                      {item.creationDatePersian}
                    </b>
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    md={1}
                    style={{
                      color: "#34495E",
                      position: "sticky",
                      left: 0,
                      background: "#fff",
                      zIndex: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <MoreHorizIcon
                      onClick={() => handleDetail(item.referenceKey)}
                      style={{ cursor: "pointer" }}
                    />{" "}
                    <b style={{ color: "#34495E" }}></b>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </section>
        </div>
      </Box>
    );
  } else if (dataFlag == "isNotSuccess") {
    return (
      <Box
        sx={{
          margin: "1.9vh",
          direction: "rtl",
          overflowX: "none",
          border: "2px solid #E57373",
        }}
      >
        <div
          className="boxView  borderCOlor"
          style={{ background: "#E57373", padding: "10px" }}
        >
          <div
            onClick={handelCollapse}
            style={{
              backgroundColor: "#E57373",
              height: "4vh",
              marginBottom: "-1.4vh",
              marginRight: "-11px",
              marginLeft: "-11px",
              marginTop: "-11px",
            }}
            className="centerVertical"
          >
            <span
              style={{
                backgroundColor: "#E57373",
                color: "#fff",
                fontSize: "16px",
                marginRight: "2vh",
              }}
            >
              <ReportGmailerrorredOutlinedIcon /> دریافت اطلاعات با خطا مواجه
              شد&nbsp;
            </span>
          </div>
        </div>
      </Box>
    );
  } else {
    return <></>;
  }
}
